import { Card } from "@mui/material";
import MDBox from "components/MDBox";
import DashboardLayout from "layouts/DashboardLayout/DashboardLayout";
import DashboardNavbar from "partials/DashboardNavbar/DashboardNavbar";
import React from "react";

export default function DashboardPage({
  children,
  renderNavbar = true,
  layoutPadding = 3,
  showBreadcrumbs = false,
  showNavbarOnAllScreens = false,
}: {
  children: React.ReactNode;
  renderNavbar?: boolean;
  layoutPadding?: number;
  showBreadcrumbs?: boolean;
  showNavbarOnAllScreens?: boolean;
}) {
  return (
    <DashboardLayout>
      <MDBox
        sx={{
          "@media print": {
            display: "none",
          },
        }}
        display={showNavbarOnAllScreens ? "block" : { sx: "block", xl: "none" }}
      >
        <DashboardNavbar showBreadcrumbs={showBreadcrumbs} renderNavbar={renderNavbar} />
      </MDBox>
      <MDBox my={3}>
        <Card>
          <MDBox p={layoutPadding}>{children}</MDBox>
        </Card>
      </MDBox>
    </DashboardLayout>
  );
}
